// src/services/super-admin/planService.js

import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}plans/`;

export default {
  getAll(params = {}) {
    return axios.get(API_URL, {
      params,
      headers: buildHeaders(),
    });
  },

  get(id) {
    return axios.get(`${API_URL}${id}`, {
      headers: buildHeaders(),
    });
  },

  create(data) {
    // JSON payload (no file here)
    return axios.post(API_URL, data, {
      headers: buildHeaders(),
    });
  },

  update(id, data) {
    return axios.put(`${API_URL}${id}`, data, {
      headers: buildHeaders(),
    });
  },

  delete(id) {
    return axios.delete(`${API_URL}${id}`, {
      headers: buildHeaders(),
    });
  },

  syncAnnualLicense(id) {
    return axios.post(`${API_URL}${id}/sync-annual-license`, {}, {
      headers: buildHeaders(),
    });
  },

  export(params = {}, format = "excel") {
    return axios.get(`${API_URL}export`, {
      params: { ...params, format },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
};
